/*
 * 催收机器人
 *
 * *
 * */
import { ticketClient } from "@/api/ticketClient";
import { LawyerLetterListReq, CallingPlanReq, LawyerLetterReq, LawyerLetter } from "@/pbjs/xcommon/ticket_pb";
import { Page, timeFormat } from "@/utils/index";
import { setCommon, setPage, handleResponse, errorMsg } from "@/utils/request";
import InnerRequest from "./request";

export interface Options {
    Page: Page;
    Orderid?: string,
    Customerid?: string,
    Customername?: string,
    Mobile?: string,
    Identity?: string,
    Assigntimerange?: string,
    Modifytimerange?: string,
    LetterStatus?: number,
    id?: number,
    UserGroupID?: number,
    PageType?: string,
    Sequence:number,
    sendtype:number,
    orderId: string
}

export function getLawyerLetterListReq(arg: Options) {
    let request: any = new LawyerLetterListReq();
    request.setPagein(setPage(arg.Page.pageIndex, arg.Page.pageSize));
    request.setOrderid(arg.Orderid)
    request.setCustomerid(arg.Customerid);
    request.setCustomername(arg.Customername);
    request.setMobile(arg.Mobile);
    request.setIdentity(arg.Identity);
    request.setAssigntimerange(arg.Assigntimerange);
    request.setModifytimerange(arg.Modifytimerange);
    request.setUsergroupid(arg.UserGroupID)
    request.setPagetype(arg.PageType)
    request.setSequence(arg.Sequence)
    return request;
}
//  获取律师函列表
export const getLawyerLetterListRequest = new InnerRequest(
    ticketClient,
    ticketClient.getLawyerLetterList
);
//保存律师函
export function SaveLawyerLetterReq(arg: Options) {
    let setDataInffo: any = new LawyerLetterReq();
    let request: any = new LawyerLetter();
    request.setOrderid(arg.Orderid)
    request.setCustomerid(arg.Customerid);
    // request.setUsergroupid(arg.UserGroupID)
    setDataInffo.setData(request)
    // setDataInffo.setUsergroupid(arg.UserGroupID)
    return setDataInffo;
}
//  保存律师函
export const SaveLawyerLetterRequest = new InnerRequest(
    ticketClient,
    ticketClient.saveLawyerLetter
);
//修改律师函
export function changeLawyerLetterReq(arg: Options) {
    let setDataInffo: any = new LawyerLetterReq();
    let request: any = new LawyerLetter();
    request.setLetterstatus(arg.LetterStatus)
    request.setId(arg.id)
    request.setOrderid(arg.orderId)
    request.setSendtype(arg.sendtype)
    // setDataInffo.setUsergroupid(arg.UserGroupID)
    setDataInffo.setData(request)
    return setDataInffo;
}
//  修改律师函
export const changeLawyerLetterRequest = new InnerRequest(
    ticketClient,
    ticketClient.modifyLawyerLetterStatus
);
// 导出律师函
export function exportLawyerLetterListReq(arg: Options) {
    let request: any = new LawyerLetterListReq();
    request.setPagein(setPage(arg.Page.pageIndex, arg.Page.pageSize));
    request.setOrderid(arg.Orderid)
    request.setCustomerid(arg.Customerid);
    request.setCustomername(arg.Customername);
    request.setMobile(arg.Mobile);
    request.setIdentity(arg.Identity);
    request.setAssigntimerange(arg.Assigntimerange);
    request.setModifytimerange(arg.Modifytimerange);
    request.setUsergroupid(arg.UserGroupID)
    request.setPagetype(arg.PageType)
    request.setSequence(arg.Sequence)
    return request;
}
//  导出律师函列表
export const exportLawyerLetterListRequest = new InnerRequest(
    ticketClient,
    ticketClient.getLawyerLetterStatsExcel
);
// export function deleteCallingPlanReq(arg: Options) {
//     let request: any = new CallingPlanReq();
//     request.setId(arg.id);
//     request.setPlanname(arg.planName)
//     request.setStrategy(arg.strategy);
//     request.setTimerange(arg.timeRange);
//     return request;
// }
// //  删除机器人
// export const deleteCallingPlanRequest = new InnerRequest(
//     ticketClient,
//     ticketClient.delCallingPlan
// );